
import { types, explanations } from '../shared/ordercontrolrestrictions';

export const restrictions = [
    {
        type: types.idCustomerInState,
        state: ['California'],
        id: [15464, 744, 5598, 8285, 19441],
        message: explanations.notInArea
    },
    {
        type: types.idCustomerInState,
        state: ['New Mexico'],
        id: [13617, 14653, 13613],
        message: explanations.notInArea
    }
];